export const convertSingleSelectToMultiSelect = (state) => {
  if (state?.type === 'singleSelect') {
    const selected = state.selected;
    state.set({
      display: state.display,
      name: state.name,
      type: 'multiSelect',
      selected: selected ? [selected] : null,
      selectedVal: [selected.value],
    });
  }
};
